import type { GridColDef } from '@mui/x-data-grid';

import { nameof } from '@e-socna/utils';

import type { LocalityInfosPage_List_LocalityInfo } from '.';

import { earthquakeZoneLabels } from '../utils/earthquake-zone-labels.util';
import { snowZoneLabels } from '../utils/snow-zone-labels.util';
import { windZoneLabels } from '../utils/wind-zone-labels.util';

const valueOoptionsFactory = (valueMap: Record<string, string>) =>
  Object.entries(valueMap).map(([key, val]) => ({
    value: key,
    label: val,
  }));

export const columns: readonly GridColDef<LocalityInfosPage_List_LocalityInfo>[] =
  [
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('locality'),
      headerName: 'Commune',
      width: 350,
      description: 'Commune',
      editable: false,
      sortable: true,
      type: 'string',
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('departmentCode'),
      headerName: 'Code département',
      width: 150,
      description: 'Code département',
      editable: false,
      sortable: true,
      type: 'string',
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('postalCode'),
      headerName: 'Code postal',
      width: 150,
      description: 'Code postal',
      editable: false,
      sortable: true,
      type: 'string',
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('departmentName'),
      headerName: 'Département',
      width: 150,
      description: 'Département',
      editable: false,
      sortable: true,
      type: 'string',
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('earthquakeZone'),
      headerName: 'Zone sismique',
      width: 150,
      description: 'Zone sismique',
      editable: false,
      sortable: true,
      type: 'singleSelect',
      valueOptions: valueOoptionsFactory(earthquakeZoneLabels),
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('snowZone'),
      headerName: 'Zone neige',
      width: 150,
      description: 'Zone neige',
      editable: false,
      sortable: true,
      type: 'singleSelect',
      valueOptions: valueOoptionsFactory(snowZoneLabels),
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('windZone'),
      headerName: 'Zone vent',
      width: 150,
      description: 'Zone vent',
      editable: false,
      sortable: true,
      type: 'singleSelect',
      valueOptions: valueOoptionsFactory(windZoneLabels),
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('distanceInKm'),
      headerName: 'Distance en KM',
      width: 150,
      description: 'Distance en KM',
      editable: false,
      sortable: true,
      type: 'number',
    },
    {
      field: nameof<LocalityInfosPage_List_LocalityInfo>('altitudeInM'),
      headerName: 'Altitude en M',
      width: 150,
      description: 'Altitude en M',
      editable: false,
      sortable: true,
      type: 'number',
    },
  ] as const;
